import RequestAbstract from "./RequestAbstract";

export default class JasperReports extends RequestAbstract {
    get link() {
        return this.links.jasperReports;
    }

    async getPdf(name, params) {
        const resp = await this.post(this.link + "/token", { name, params, });

        if (!resp?.data?.token?.length)
            return "";

        //return globalThis.packageInfo.proxy + this.getFullLink(this.links.pdfToken) + resp.data.token;
        return globalThis.packageInfo.proxyJasper + this.getFullLink(this.links.pdfToken) + resp.data.token;
    }

    getParams(name) {
        const arr = [
            { field: "name", op: "=", value: name }
        ];

        return this.getAllFiltered([arr]);
    }
}
